
// 保障权益
const bzqy = [{
  title: '意外身故及残疾保险金',
  planA: '300,000',
}, {
  title: '公共交通工具意外身故及残疾保险金 （不适用于未成年人）',
  planA: '300,000',
}, {
  title: '医疗费用补偿（含门急诊及住院医疗）*其中因投保前患有的心脑血管疾病、高血压及糖尿病导致的医疗费用20,000元',
  planA: '300,000',
}, {
  title: '每日住院津贴收入保障（30天为限）',
  planA: '100元/天',
}, {
  title: '医疗运送与送返',
  planA: '300,000',
}, {
  title: '身故遗体送返及丧葬费用 *其中丧葬费用限额',
  planA: '300,000',
}, {
  title: '慰问及探访费用',
  planA: '5,000',
}, {
  title: '护送未满十六周岁儿童回国',
  planA: '5,000',
}, {
  title: '旅行者行李及随身财产 *其中每件或每套行李或物品赔偿限额1000元每部手机赔偿限额500元',
  planA: '2,000',
}, {
  title: '旅行行李延误（每6小时赔偿限额：RMB500元) ',
  planA: '500',
}, {
  title: '个人钱财损失',
  planA: '2,000',
}, {
  title: '旅行证件遗失',
  planA: '1,000',
}, {
  title: '旅行延误(每5小时赔偿限额：300元) ',
  planA: '300',
}, {
  title: '旅行个人责任',
  planA: '200,000',
}, {
  title: '旅行者信用卡盗刷（不适用于未成年人）',
  planA: '3,000',
}, {
  title: '绑架及劫持津贴（赔偿天数上限为30天）',
  planA: '500元/天',
}, {
  title: '旅行家居财物保障 *其中每件/套物品赔偿限额：RMB1000元。',
  planA: '5,000',
}, {
  title: '保障期间自动延长',
  planA: '最长10天',
}];
const bzqyEn = [{
  title: 'Accidental Death & Dismemberment',
  planA: '300,000',
}, {
  title: 'Carrier Accident Benefit(Not Applicable to Children Under 18 Years of Age)',
  planA: '300,000',
}, {
  title: 'Medical Reimbursement(Incl. Outpatient and Inpatient) Medical reimbursement due to pre-existing cardiovascular and cerebrovascular disease, hypertensive disease or diabetes limit to RMB20,000',
  planA: '300,000',
}, {
  title: 'Daily Hospital Income Indemnity（up to 30 days）',
  planA: 'RMB 100/day',
}, {
  title: 'Emergency Evacuation & Repatriation',
  planA: '300,000',
}, {
  title: 'Repatriation of Mortal Remains and Funeral Expense *Funeral Expense Limited to RMB20,000',
  planA: '300,000',
}, {
  title: 'Compassionate Visitation',
  planA: '5,000',
}, {
  title: 'Escorting Children under 16 back to China',
  planA: '5,000',
}, {
  title: 'Baggage and Personal Effects（RMB1000 per item or set of items,RMB500 per mobile phone）',
  planA: '2,000',
}, {
  title: 'Baggage Delay (RMB500 for Every 6 Hours of Delay)',
  planA: '500',
}, {
  title: 'Loss of Money',
  planA: '2,000',
}, {
  title: 'Loss of Travel Document',
  planA: '1,000',
}, {
  title: 'Travel Delay (RMB300 for Every 5 Hours of Delay)',
  planA: '300',
}, {
  title: 'Personal Liability',
  planA: '200,000',
}, {
  title: 'Credit Card Fraudulent Charges (Not Applicable to Children Under 18 Years)',
  planA: '3,000',
}, {
  title: 'Kidnapping and Hostage Allowance (up to 30 days）',
  planA: 'RMB 500/day',
}, {
  title: 'Home Care * RMB1000 per item or set of items',
  planA: '5,000',
}, {
  title: 'Automatic Extension of Coverage',
  planA: 'Up to 10 days',
}];
const plan1 = [{
  min: 1,
  max: 3,
  value: 95
}, {
  min: 4,
  max: 7,
  value: 198,
}, {
  min: 8,
  max: 10,
  value: 255
}, {
  min: 11,
  max: 14,
  value: 325
}, {
  min: 15,
  max: 17,
  value: 450
}, {
  min: 18,
  max: 21,
  value: 550
}, {
  min: 22,
  max: 24,
  value: 580
}, {
  min: 25,
  max: 28,
  value: 650
}, {
  avg: 130,
  year: 2300
}];
const planPremiumTable = {
  1: plan1,
}
const calcPremium = (plan, days) => {
  let sum = 0
  console.log(plan, days)
  const plan1 = planPremiumTable[1]
  if (days == 'year') {
      sum = plan1[plan1.length - 1].year
  } else if (days > 28) {
      let num = Math.floor(days / 7) + (days % 7 == 0 ? 0 : 1)
      sum = plan1[plan1.length - 2].value + plan1[plan1.length - 1].avg * (num - 4)
  } else {
      const item = plan1.filter(item => {
          return item.min <= days && days <= item.max
      })
      sum = item[0].value
  }
  
  return sum.toFixed(2)
}
const premiumRules = [{
  days: '1-3',
  plan1: '95',
}, {
  days: '4-7',
  plan1: '198',
}, {
  days: '8—10',
  plan1: '255',
}, {
  days: '11-14',
  plan1: '325',
}, {
  days: '15-17',
  plan1: '450',
}, {
  days: '18-21',
  plan1: '550',
}, {
  days: '22-24',
  plan1: '580',
}, {
  days: '25-28',
  plan1: '650',
}, {
  days: '28天以上（每增加一周）',
  plan1: '650 + 130*周数',
}, {
  days: '1年（每次旅行的保障期限最长为182天）',
  plan1: '2300',
}];
const premiumRulesEn = [{
  days: '1-3',
  plan1: '95',
}, {
  days: '4-7',
  plan1: '198',
}, {
  days: '8—10',
  plan1: '255',
}, {
  days: '11-14',
  plan1: '325',
}, {
  days: '15-17',
  plan1: '450',
}, {
  days: '18-21',
  plan1: '550',
}, {
  days: '22-24',
  plan1: '580',
}, {
  days: '25-28',
  plan1: '650',
}, {
  days: 'one week after 4 weeks',
  plan1: '650 RMB + 130 RMB * No.of Weeks',
}, {
  days: '1 year with 182 days per trip max',
  plan1: '2300',
},]
const premiumColumns = [{
  title: '保险期间（天）',
  dataIndex: 'days',
  key: 'days'
}, {
  title: '保费',
  dataIndex: 'plan1',
  key: 'plan1'
}]
const premiumColumnsEn = [{
  title: 'Duration（day）',
  dataIndex: 'days',
  key: 'days'
}, {
  title: 'Premium',
  dataIndex: 'plan1',
  key: 'plan1'
}]
const planDays = ['1-3', '4-7', '8-10', '11-14', '15-17', '18-21', '22-24', '25-28'];
const columns = [
  {
      title: "保障内容",
      dataIndex: "title",
      key: "title",
  },
  {
      title: "保障区域：全球（含申根国家）",
      dataIndex: "planA",
      width: 150,
      key: "planA",
  },
];
const columnsEn = [
  {
      title: "BOCI Schengen Travel Plan Insurance",
      dataIndex: "title",
      key: "title",
  },
  {
      title: "Economic Plan",
      dataIndex: "planA",
      width: 150,
      key: "planA",
  },
];
const plans = ['盛游全球-个人境外旅行保险（签证专款）短期计划', '盛游全球-个人境外旅行保险（签证专款）年单计划'];
const plansEn = ['vigorous traveler insurance （VISA）short-term plan', 'vigorous traveler insurance （VISA）annual plan'];

// 阅读文件
const fileList = {
  1: `https://image.ssish.com/static/product/axatp009/pdf/axatp009_tk.pdf?time=${new Date().getTime()}`, //安盛的保险条款
  2: `https://image.ssish.com/static/product/axatp009/pdf/axatp009_cwzr.pdf?time=${new Date().getTime()}`, //安盛的免责声明
  4: `https://image.ssish.com/core/material/20230905153255_宇泰保险经纪（北京）有限公司20230828.pdf`, // 客户告知书
}

export {
  plans,
  plansEn,
  columns,
  columnsEn,
  planDays,
  bzqy,
  bzqyEn,
  calcPremium,
  premiumRules,
  premiumRulesEn,
  premiumColumns,
  premiumColumnsEn,
  fileList
}